import { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { toast } from "sonner";

const OPTS = [["gestao", "Gestão processual"], ["consultor", "Consultor responsável"], ["ambos", "Ambos"]];

export function ReviewBy() {
  const [v, setV] = useState(null);
  useEffect(() => { api.get("/agency/review-by").then(({ data }) => setV(data.review_by)); }, []);
  if (!v) return null;
  const save = async (review_by) => {
    try { await api.put("/agency/review-by", { review_by }); setV(review_by); toast.success("Guardado"); }
    catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
  };
  return (
    <div className="bg-white rounded-[16px] p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-slate-100" data-testid="review-by-card">
      <h3 className="font-heading text-lg text-ec-green">Quem revê os documentos recebidos</h3>
      <p className="text-sm text-slate-500 mt-1">Os documentos e avisos de cada processo aparecem em «Documentos para rever» (Hoje) de quem escolher. O Consultor só vê os dos seus processos.</p>
      <div className="mt-4 grid grid-cols-3 gap-2 max-w-lg">
        {OPTS.map(([k, l]) => (
          <button key={k} onClick={() => save(k)} data-testid={`review-by-${k}`}
            className={`py-2 rounded-lg border text-sm transition-colors ${v === k ? "border-ec-green bg-ec-green text-white" : "border-slate-200 bg-white text-slate-600 hover:bg-slate-50"}`}>{l}</button>
        ))}
      </div>
    </div>
  );
}

export function TreatDefault() {
  const [v, setV] = useState(null);
  useEffect(() => { api.get("/agency/settings").then(({ data }) => setV(data.default_treat || "sr")); }, []);
  if (!v) return null;
  const save = async (treat) => {
    try { await api.put("/agency/treat", { treat }); setV(treat); toast.success("Guardado"); }
    catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
  };
  return (
    <div className="bg-white rounded-[16px] p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-slate-100" data-testid="treat-card">
      <h3 className="font-heading text-lg text-ec-green">Tratamento dos clientes</h3>
      <p className="text-sm text-slate-500 mt-1">Como a app trata os novos clientes nas mensagens e nos lembretes. Pode ser mudado em cada parte do processo.</p>
      <div className="mt-4 grid grid-cols-2 gap-2 max-w-md">
        {[["sr", "Sr./Sra. + primeiro nome"], ["first", "Primeiro nome"]].map(([k, l]) => (
          <button key={k} onClick={() => save(k)} data-testid={`treat-default-${k}`}
            className={`py-2 rounded-lg border text-sm transition-colors ${v === k ? "border-ec-green bg-ec-green text-white" : "border-slate-200 bg-white text-slate-600 hover:bg-slate-50"}`}>{l}</button>
        ))}
      </div>
    </div>
  );
}


export function CmiCertToggle() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/agency/cmi-settings").then(({ data }) => setS(data)); }, []);
  if (!s?.enabled) return null;
  const v = s.require_valid_certidao;
  const save = async () => {
    try { await api.put("/agency/cmi-certidao", { require: !v }); setS({ ...s, require_valid_certidao: !v }); toast.success("Guardado"); }
    catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
  };
  return (
    <div className="bg-white rounded-[16px] p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-slate-100 flex items-center gap-4" data-testid="cmi-cert-card">
      <div className="flex-1">
        <h3 className="font-heading text-lg text-ec-green">Exigir certidão válida para o CMI</h3>
        <p className="text-sm text-slate-500 mt-1">Desligado: para o CMI basta haver certidão permanente; se tiver mais de 6 meses aparece só um aviso. A validade de 6 meses conta sempre para a escritura.</p>
      </div>
      <button onClick={save} role="switch" aria-checked={v} data-testid="cmi-cert-toggle"
        className={`w-12 h-7 rounded-full relative transition-colors ${v ? "bg-ec-green" : "bg-slate-300"}`}>
        <span className={`absolute top-1 w-5 h-5 rounded-full bg-white transition-transform ${v ? "translate-x-6" : "translate-x-1"} left-0`} />
      </button>
    </div>
  );
}

export function AssinajaToggle() {
  const [s, setS] = useState(null);
  const [cmi, setCmi] = useState(false);
  useEffect(() => {
    api.get("/agency/assinaja").then(({ data }) => setS(data));
    api.get("/agency/cmi-settings").then(({ data }) => setCmi(!!data.enabled));
  }, []);
  if (!s || !cmi) return null;
  const save = async () => {
    try { const { data } = await api.put("/agency/assinaja", { enabled: !s.enabled }); setS(data); toast.success("Guardado"); }
    catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
  };
  return (
    <div className="bg-white rounded-[16px] p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-slate-100 flex items-center gap-4" data-testid="assinaja-card">
      <div className="flex-1">
        <h3 className="font-heading text-lg text-ec-green">Assinatura digital (AssinaJá)</h3>
        <p className="text-sm text-slate-500 mt-1" data-testid="assinaja-status">Assinatura digital: <span className="font-semibold">{s.enabled ? "ligada" : "desligada"}</span>. {s.enabled ? "O CMI pode ser enviado para assinatura digital; assinam o consultor e o(s) proprietário(s)." : "O CMI só se assina em papel (descarregar e carregar o assinado)."}</p>
        <p className="text-xs text-slate-500 mt-1" data-testid="assinaja-type">Tipo por defeito: {s.signature_type}</p>
      </div>
      <button onClick={save} role="switch" aria-checked={s.enabled} data-testid="assinaja-toggle"
        className={`w-12 h-7 rounded-full relative transition-colors ${s.enabled ? "bg-ec-green" : "bg-slate-300"}`}>
        <span className={`absolute top-1 w-5 h-5 rounded-full bg-white transition-transform ${s.enabled ? "translate-x-6" : "translate-x-1"} left-0`} />
      </button>
    </div>
  );
}


export function KycToggle() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/agency/cmi-settings").then(({ data }) => setS(data)); }, []);
  if (!s) return null;
  const save = async (k, v) => {
    try { await api.put("/agency/kyc", { [k]: v }); setS({ ...s, [{ job_proof: "kyc_job_proof", consultant_validate: "kyc_consultant_validate" }[k]]: v }); toast.success("Guardado"); }
    catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
  };
  const Sw = ({ on, onClick, testid }) => (
    <button onClick={onClick} role="switch" aria-checked={on} data-testid={testid} className={`w-12 h-7 shrink-0 rounded-full relative transition-colors ${on ? "bg-ec-green" : "bg-slate-300"}`}>
      <span className={`absolute top-1 w-5 h-5 rounded-full bg-white transition-transform ${on ? "translate-x-6" : "translate-x-1"} left-0`} />
    </button>
  );
  return (
    <div className="bg-white rounded-[16px] p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-slate-100 space-y-4" data-testid="kyc-card">
      <div>
        <h3 className="font-heading text-lg text-ec-green">Recolha de identificação (branqueamento de capitais)</h3>
        <p className="text-sm text-slate-500 mt-1">No fim do portal, o cliente preenche a ficha de identificação (Lei 83/2017): identificação, representação, cargos públicos e transação. A gestão processual ou a direção validam; um «Sim» ou um país de risco elevado passa pela Direção.</p>
        <p className="text-sm mt-2 font-semibold text-ec-green" data-testid="kyc-status">{s.kyc_enabled ? "Sempre ligada: é uma obrigação legal." : "Desligada pelo administrador da plataforma (agência de demonstração)."}</p>
      </div>
      {s.kyc_enabled && (
        <div className="flex items-center gap-4 border-t border-slate-100 pt-4">
          <div className="flex-1 text-sm text-slate-700">Exigir comprovativo da profissão <span className="text-slate-500">(por defeito basta escrever a profissão)</span></div>
          <Sw on={s.kyc_job_proof} onClick={() => save("job_proof", !s.kyc_job_proof)} testid="kyc-proof-toggle" />
        </div>
      )}
      {s.kyc_enabled && (
        <div className="border-t border-slate-100 pt-4 space-y-2">
          <div className="flex items-center gap-4">
            <div className="flex-1 text-sm text-slate-700">Consultores podem validar fichas sem alertas <span className="text-slate-500">(para agências sem gestão processual)</span></div>
            <Sw on={s.kyc_consultant_validate} onClick={() => save("consultant_validate", !s.kyc_consultant_validate)} testid="kyc-consultant-toggle" />
          </div>
          <p className="text-xs rounded-lg bg-amber-50 text-amber-900 px-3 py-2" data-testid="kyc-consultant-warning">Atenção: com esta opção ligada, a responsabilidade pela validação das fichas feita pelos consultores é da agência.</p>
        </div>
      )}
    </div>
  );
}

